import * as React from "react";
const SvgBenchmarkLowest = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 9, viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L7.51365 8.33333L15.0273 0H0Z", fill: "#F1695F" }));
export default SvgBenchmarkLowest;
